import { RouterProvider as ReactRouterProvider } from 'react-router/dom'

import {
  useAppAvailable,
  useInitData,
  useIsExternalContactProfileNGAvailable,
  useIsProviderProfileNGAvailable,
  useIsUserProfileNGAvailable,
  useUserData,
} from '../hooks'
import { getAppRouter } from '../router'
import { hasDashboardAccess, isWorkerUser } from '../utils/user'

function RouterProvider() {
  const { authorized, availableSections, sections } = useInitData()
  const appAvailable = useAppAvailable()
  const isExternalContactProfileNGAvailable =
    useIsExternalContactProfileNGAvailable()
  const isProviderProfileNGAvailable = useIsProviderProfileNGAvailable()
  const isUserProfileNGAvailable = useIsUserProfileNGAvailable()
  const userData = useUserData()

  // The router depends on the role only: a router rebuilt per refetched user
  // inherits the mounted page's stale navigation blocker
  const role = userData?.role

  const router = getAppRouter({
    appAvailable,
    authorized,
    availableSections,
    hasDashboard: hasDashboardAccess({ role }),
    isExternalContactProfileNGAvailable,
    isProviderProfileNGAvailable,
    isUserProfileNGAvailable,
    isWorker: isWorkerUser({ role }),
    sections,
  })

  return <ReactRouterProvider router={router} />
}

export default RouterProvider
